"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRACKER_CONFIG = exports.SNOWPLOW_TRACKER_NAME = void 0;
/**
 * This is the name of the tracker that will appear in the cookies.
 * Default is 'sp', however that could be confused with Service Provider so
 * opted to rename to 'snpl'.
 */
exports.SNOWPLOW_TRACKER_NAME = 'snpl';
/**
 * Configuration to be used when initializing the Snowplow Tracker.
 */
exports.DEFAULT_TRACKER_CONFIG = {
  platform: 'web',
  cookieName: exports.SNOWPLOW_TRACKER_NAME,
  cookieSameSite: 'Lax',
  respectDoNotTrack: false,
  discoverRootDomain: true,
  contexts: {
    webPage: true,
    session: true,
    browser: true
  }
};